import { render, staticRenderFns } from "./agentDetail.vue?vue&type=template&id=70f36489&"
import script from "./agentDetail.vue?vue&type=script&lang=js&"
export * from "./agentDetail.vue?vue&type=script&lang=js&"
import style0 from "./agentDetail.vue?vue&type=style&index=0&id=70f36489&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports